import styled from 'styled-components'

export const AppWrapper = styled.div`
    display: grid;
    grid-template-rows: auto;
    align-content: stretch;
    height: 100vh;
    background: #9AA6D3;
`